export default "__VITE_ASSET__D_mB_B8b__"